export interface SelectOption<TValue> {
	label: string;
	value: TValue;
}

export interface SelectOptionGroup<TValue> {
	label: string;
	options: Array<SelectOption<TValue>>;
}

export const isSelectOption = (
	optionOrGroup: SelectOptionGroup<unknown> | SelectOption<unknown>,
): optionOrGroup is SelectOption<unknown> => !("options" in optionOrGroup);
